import React, { createContext, ReducerAction, useContext, useReducer } from "react";
import { theme } from "@instructure/canvas-theme";
import getMetaTagData from "./getMetaTagData";
import { AppState } from "./appInitialState";

export const StateContext = createContext<[AppState, React.DispatchWithoutAction]>(null);

const StateProvider = ({ initialState, reducer, children }) => {
  const htmlMetaTagData = getMetaTagData();
  // Set themes from canvasBrandConfig passed in
  // https://github.com/instructure/instructure-ui/tree/master/packages/ui-themes
  if (htmlMetaTagData.canvasBrandConfig !== "") {
    theme.use({ overrides: { ...htmlMetaTagData.canvasBrandConfig } });
  }

  return (
    <StateContext.Provider
      value={useReducer(reducer, { ...initialState, ...htmlMetaTagData }) as any}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateValue = () => useContext(StateContext);

export default StateProvider;
